import module from 'module';

import templateUrl from './stock-item-retag.template.html';
const auctionTagPath = `/dashboard/appraisals/auction-tag`;

class StockItemRetag {
  constructor($routeParams, $location, command, commandAccessChecker, pawnItemCache, reportModal) {
    this.$routeParams = $routeParams;
    this.$location = $location;
    this.command = command;
    this.commandAccessChecker = commandAccessChecker;
    this.pawnItemCache = pawnItemCache;
    this.reportModal = reportModal;
  }

  async $onInit() {
    if (this.$routeParams && this.$routeParams.selectedIds) {
      let ids = this.$routeParams.selectedIds;
      if (!Array.isArray(ids)) {
        ids = [ids];
      }
      this.selectedIds = ids.map(Number);
    }

    const canExecuteCommand = await this.commandAccessChecker.canExecuteCommandPromise();

    if (!canExecuteCommand || !canExecuteCommand('StockItemRetag')) {
      this.$location.path("");
    }
  }

  async upload() {
    this.warningMessage = "";
    this.successMessage = "";
    this.notProcessed = 0;
    this.selectedIds = null;

    let fileId = this.file[0].id;
    let response = await this.command.execute('StockItemRetag', {fileId: fileId}).toPromise();

    this.pawnItemCache.evict();

    if (response && response.output) {
      if (response.output.notProcessed && response.output.notProcessed.length) {
        this.warningMessage = "The following items have not been uploaded:";
        this.notProcessed = response.output.notProcessed;
      } else {
        this.successMessage = "The file has been processed."
        this.selectedIds = response.output.processed.map(p => p.stockItemId);
      }
    }
  }

  generateAuctionReport() {
    let params = {
      ids: this.selectedIds,
      bool: true // Reusing an existing CommonReportFilter param, but this is a boolean flag to evaluate if the pawn item's selling price and cost should be used as the basis for the selling price instead of a computed value.
    };
    
    this.reportModal.display({
      params: params,
      reportCode: 'AuctionItemsReport',
      hideXls: true
    });
  }

  generateAuctionTag() {
    this.$location.path(auctionTagPath).search({
      selectedIds: this.selectedIds,
      usePawnItemSellingPriceAndCost: true
    });
  }

  $onDestroy() {
    if (this.selectedIds && this.$location.path() !== auctionTagPath) {
      this.$location.search({});
    }
  }
}

module.component('stockItemRetag', {
  templateUrl,
  controller: StockItemRetag
});